<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="3">
      <rules-status-selector v-model="filters.status" product="domain" filter />
    </v-col>
    <v-col cols="12" sm="3">
      <v-select ref="state" v-model="filters.state" :items="states" label="State" clearable />
    </v-col>
    <v-col cols="12" sm="3">
      <updated-by-selector v-model="filters.updated_by" />
    </v-col>
    <v-col cols="12" sm="3">
      <v-select
        v-model="filters.created_via_mav"
        :items="mavOptions"
        label="Created via MAV"
        clearable
      />
    </v-col>
  </v-row>
</template>

<script>
import { FiltersMixin } from '@nielsen-media/ui-toolkit-vue';
import RulesStatusSelector from '@/components/cls/RulesStatusSelector.vue';
import UpdatedBySelector from '@/components/cls/UpdatedBySelector.vue';

export default {
  components: { UpdatedBySelector, RulesStatusSelector },
  mixins: [FiltersMixin],
  props: {
    states: { type: Array, required: true },
  },
  data: () => ({
    mavOptions: [
      { text: 'Yes', value: 'true' },
      { text: 'No', value: 'false' },
    ],
    filters: {
      status: 'active',
      state: null,
      updated_by: null,
      created_via_mav: null,
    },
  }),
};
</script>
